module.exports = __webpack_public_path__ + "media/images/resource-types/image-4e8a7444f67d2e644dcca3bc00ce4ea8.svg";